<template>
  <v-container class="pa-4">
    <v-card elevation="2" class="pa-6 rounded-lg">
      <v-row class="mb-4">
        <v-col cols="12">
          <h2 class="text-h5 font-weight-medium mb-2">📊 لوحة الاستبيانات</h2>
          <p class="text-body-2 text-grey-darken-1">اختر الاستبيان لعرض الإحصائيات الخاصة به</p>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" md="6">
          <v-select
            v-model="selectedSurveyId"
            :items="surveys"
            item-title="name"
            item-value="_id"
            label="اختر الاستبيان"
            variant="outlined"
            density="comfortable"
            clearable
            prepend-inner-icon="mdi-format-list-bulleted"
          />
        </v-col>
      </v-row>
    </v-card>

    <v-expand-transition>
      <v-row v-if="selectedSurveyId" class="mt-6">
        <v-col>
          <SurveyStatistics :survey-id="selectedSurveyId" />
        </v-col>
      </v-row>
    </v-expand-transition>
  </v-container>
</template>

<script>
import SurveyStatistics from '@/components/survey/SurveyStatistics.vue';
import repository from '@/api/repository';

export default {
  components: {
    SurveyStatistics
  },
  data() {
    return {
      selectedSurveyId: '',
      surveys: []
    };
  },
  mounted() {
    this.loadSurveys();
  },
  methods: {
    async loadSurveys() {
      try {
        const res = await repository.index('surveys');
        if (res?.data?.success) {
          this.surveys = res.data.data;
        } else {
          console.error("Invalid response", res);
        }
      } catch (err) {
        console.error("Error fetching surveys", err);
      }
    }
  }
};
</script>

<style scoped>
h2 {
  color: #424242;
}
</style>
